import React, { useState, useEffect } from "react";
import axios from "axios";
import TableOne from "../Table/TableOne"; // Import your table component
import Modal from "react-modal";
import "./../style/common.css";
import "./../Table/table.css";
import "./../style/pop-up.css";
import { CiWarning } from "react-icons/ci";
import {
  TextField,
  MenuItem,
  Radio,
  RadioGroup,
  FormHelperText,
} from "@mui/material";
import {
  FaUserTie,
  FaUser,
  FaAddressCard,
  FaCity,
  FaSearch,
  FaBuilding,
} from "react-icons/fa";
import { MdEmail } from "react-icons/md";
import { TbMapPinCode } from "react-icons/tb";
import { RiLockPasswordFill } from "react-icons/ri";
import { FaMobileRetro, FaTreeCity } from "react-icons/fa6";
import { InputAdornment } from "@mui/material";
import { GiWorld } from "react-icons/gi";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Admin = () => {
  const [admin, setAdmin] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [country, setCountry] = useState([]);
  const [state, setState] = useState([]);
  const [city, setCity] = useState([]);
  const [errors, setErrors] = useState({});
  const [filteredAdmin, setFilteredAdmin] = useState([]);
  const [company, setCompany] = useState([]);
  const [selectedFile, setSelectedFile] = useState([]);
  const [adminProfile, setAdminProfile] = useState("../images/imageicon.png"); // State to store profile image
  const [admins, setAdmins] = useState([]);
  const [filteredAdmins, setFilteredAdmins] = useState([]);
  // State for delete confirmation
  const [deleteAdminId, setDeleteAdminId] = useState(null);
  const [deleteAdminName, setDeleteAdminName] = useState("");
  const [showDeleteAdminBox, setShowDeleteAdminBox] = useState(false);
  const [showUploadConfirm, setShowUploadConfirm] = useState(false);
  const [uploadAdminName, setUploadAdminName] = useState("");
  const [pendingFile, setPendingFile] = useState(null);
  const [pendingAdminId, setPendingAdminId] = useState(null);

  const [formData, setFormData] = useState({
    admin_company_id: "",
    admin_fullname: "",
    admin_email: "",
    admin_password: "",
    admin_gender: "male",
    admin_contact: "",
    admin_country: "",
    admin_state: "",
    admin_city: "",
    admin_address: "",
    admin_pincode: "",
    admin_profile: "",
    admin_islastlogin: "",
    admin_dateofjoin: "",
    admin_dateofleave: "",
    admin_isactive: true,
  });

  const [editMode, setEditMode] = useState(false);
  const handleFileChange = (event) => {
    setSelectedFile(event.target.files[0]);
  };

  // Fetch Company data from the API
  const fetchCompany = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        "https://aligndesk.dropyourbusiness.com/api/company"
      );
      const companyData = response.data.company.map((company) => ({
        CompanyId: company.company_id,
        CompanyName: company.company_name,
      }));
      setCompany(companyData);
    } catch (error) {
      console.error("Error fetching company data:", error);
    }
    setLoading(false);
  };
  useEffect(() => {
    fetchCompany();
  }, []);

  // Fetch Country data from the API
  const fetchCountry = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        "https://aligndesk.dropyourbusiness.com/api/countries"
      );
      const countryData = response.data.data.map((country) => ({
        CountryId: country.id,
        CountryName: country.name,
      }));
      console.log("countryData-->", country);
      setCountry(countryData);
    } catch (error) {
      console.error("Error fetching country data:", error);
    }
    setLoading(false);
  };

  // Fetch State data based on selected Country
  const fetchState = async (countryId) => {
    setLoading(true);
    try {
      const response = await axios.get(
        `https://aligndesk.dropyourbusiness.com/api/states/${countryId}`
      );
      console.log("stateData-->", response.data);
      const stateData = response.data.data.map((state) => ({
        StateId: state.id,
        StateName: state.name,
      }));
      setState(stateData);
      setCity([]);
    } catch (error) {
      console.error("Error fetching state data:", error);
    }
    setLoading(false);
  };

  // Fetch City data based on selected State
  const fetchCity = async (stateId) => {
    setLoading(true);
    try {
      const response = await axios.get(
        `https://aligndesk.dropyourbusiness.com/api/cities/${stateId}`
      );
      const cityData = response.data.data.map((city) => ({
        CityId: city.id,
        CityName: city.name,
      }));
      setCity(cityData);
    } catch (error) {
      console.error("Error fetching city data:", error);
    }
    setLoading(false);
  };
  useEffect(() => {
    fetchCountry();
  }, []);

  useEffect(() => {
    if (formData.admin_country) {
      fetchState(formData.admin_country);
    }
  }, [formData.admin_country]);

  useEffect(() => {
    if (formData.admin_state) {
      fetchCity(formData.admin_state);
    }
  }, [formData.admin_state]);

  // Fetch admin data from the API
  const fetchAdmin = async () => {
    setLoading(true);
    try {
      const adminResponse = await axios.get(
        "https://aligndesk.dropyourbusiness.com/api/admin"
      );
      const companyResponse = await axios.get(
        "https://aligndesk.dropyourbusiness.com/api/company"
      );
      //Mapping for company
      const companyMap = companyResponse.data.company.reduce((map, company) => {
        map[company.company_id] = company.company_name;
        return map;
      }, {});
      const adminData = adminResponse.data.admin.map((a) => ({
        company_id: a.admin_company_id,
        CompanyName: companyMap[a.admin_company_id] || "Unknown",
        Admin_id: a.admin_id,
        FullName: a.admin_fullname,
        Email: a.admin_email,
        Gender: a.admin_gender,
        Contact: a.admin_contact,
        Country: a.admin_country,
        State: a.admin_state,
        City: a.admin_city,
        Address: a.admin_address,
        Pincode: a.admin_pincode,
        DateofJoin: a.admin_dateofjoin,
        DateofLeave: a.admin_dateofleave,
        IsLastLogin: a.admin_islastlogin,
        IsActive: a.admin_isactive,
        Profile: a.admin_profile || "../images/imageicon.png", // Default image callback
      }));
      if (adminData.length > 0) {
        setAdminProfile(adminData[0].Profile); // Set first admin's profile as default
      }
      setAdmin(adminData);
      setFilteredAdmin(adminData);
    } catch (error) {
      console.error("Error fetching admin data:", error);
    }
    setLoading(false);
  };
  useEffect(() => {
    fetchAdmin();
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const openModal = (admin = null) => {
    if (admin) {
      setFormData(admin);
    } else {
      setFormData({
        admin_company_id: "",
        admin_fullname: "",
        admin_email: "",
        admin_password: "",
        admin_gender: "",
        admin_contact: "",
        admin_country: "",
        admin_state: "",
        admin_city: "",
        admin_address: "",
        admin_pincode: "",
        admin_profile: "",
        admin_islastlogin: "",
        admin_dateofjoin: "",
        admin_dateofleave: "",
        admin_isactive: true,
      });
      setEditMode(false);
    }
    setErrors({});
    setIsModalOpen(true);
  };
  const closeModal = () => {
    setIsModalOpen(false);
  };

  // Open delete confirmation pop-up
  const handleDelete = (admin) => {
    setDeleteAdminId(admin.Admin_id);
    setDeleteAdminName(admin.FullName || "Unnamed Admin"); // Assuming FullName exists
    setShowDeleteAdminBox(true);
  };

  // Confirm deletion
  const confirmDeleteAdmin = async () => {
    if (!deleteAdminId) return;
    try {
      const response = await axios.delete(
        `https://aligndesk.dropyourbusiness.com/api/admin/delete/${deleteAdminId}`
      );
      if (response.status === 200) {
        toast.success("Admin deleted successfully!");
        setShowDeleteAdminBox(false); // Close delete confirmation popup
        // Fetch updated admin list instead of reloading the page
        fetchAdmin();
      }
    } catch (error) {
      console.error("Error deleting admin:", error);
      toast.error("An error occurred while deleting the Admin.");
    }
  };

  // Cancel deletion
  const cancelDeleteAdmin = () => {
    setShowDeleteAdminBox(false);
  };

  const handleEdit = (admin) => {
    setFormData({
      admin_id: admin.Admin_id,
      admin_company_id: admin.company_id || "",
      admin_fullname: admin.FullName || "",
      admin_email: admin.Email || "",
      admin_gender: admin.Gender || "male",
      admin_contact: admin.Contact || "",
      admin_country:
        country.find((c) => c.CountryName === admin.Country)?.CountryId || "",
      admin_state:
        state.find((c) => c.StateName === admin.State)?.StateId || "",
      admin_city: city.find((ct) => ct.CityName === admin.City)?.CityId || "",
      admin_address: admin.Address || "",
      admin_pincode: admin.Pincode || "",
      admin_dateofjoin: admin.DateofJoin || "",
      admin_dateofleave: admin.DateofLeave || "",
      admin_isactive: admin.IsActive || true,
      admin_profile: admin.Profile || "",
    });
    setEditMode(true);
    setIsModalOpen(true);
    // console.log("edit-->",admin);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const validateForm = () => {
      const newErrors = {};
      if (!formData.admin_company_id) {
        newErrors.admin_company_id = "Please Select Company.";
      }
      if (!formData.admin_fullname) {
        newErrors.admin_fullname = "Full Name is required.";
      }
      if (!formData.admin_email) {
        newErrors.admin_email = "Email is required.";
      } else if (!/\S+@\S+\.\S+/.test(formData.admin_email)) {
        newErrors.admin_email = "Please enter a valid email address.";
      }
      if (!editMode && !formData.admin_password) {
        newErrors.admin_password = "Password is required.";
      } else if (!editMode && formData.admin_password.length < 6) {
        newErrors.admin_password = "Password must be at least 6 characters.";
      }
      if (!editMode && !formData.admin_confirm_password) {
        newErrors.admin_confirm_password = "Confirm Password is required.";
      } else if (
        !editMode &&
        formData.admin_confirm_password !== formData.admin_password
      ) {
        newErrors.admin_confirm_password =
          "Confirm Password must be same as Password";
      }
      if (!/^\d{10}$/.test(formData.admin_contact)) {
        newErrors.admin_contact = "Contact number must be 10 digits.";
      }
      if (!/^\d{6}$/.test(formData.admin_pincode)) {
        newErrors.admin_pincode = "Pincode must be 6 digits.";
      }
      // Check for duplicate email
      const emailExists = admin.some(
        (a) => a.Email.toLowerCase() === formData.admin_email.toLowerCase()
      );
      // Check for duplicate company
      const companyExists = admin.some(
        (a) =>
          a.CompanyName.toLowerCase() ===
          company
            .find((c) => c.CompanyId === formData.admin_company_id)
            ?.CompanyName.toLowerCase()
      );
      if (emailExists && !editMode) {
        toast.error("Email already exists!");
        return false; // Prevent submission
      }
      if (companyExists && !editMode) {
        toast.error("Company Name already exists!");
        return false; // Prevent submission
      }
      return newErrors;
    };
    const errors = validateForm();
    if (errors === false) return; // Stop submission if duplicate found
    if (Object.keys(errors).length > 0) {
      setErrors(errors);
      return;
    }
    try {
      const url = editMode
        ? `https://aligndesk.dropyourbusiness.com/api/admin/update/${formData.admin_id}`
        : "https://aligndesk.dropyourbusiness.com/api/admin/add";
      const method = editMode ? "put" : "post";
      await axios({
        method,
        url,
        data: formData,
      });
      toast.success(
        editMode ? "Admin Updated Successfully!" : "Admin Added Successfully!"
      );
      fetchAdmin(); // Refresh the table
      closeModal();
    } catch (error) {
      console.error("Error submitting data:", error);
      // toast.error("Failed to submit data. Please try again.");
    }
  };

  // Table columns
  const columns = [
    { Header: "Sr.No", accessor: (row, index) => index + 1, id: "index" },
    {
      Header: "Profile",
      accessor: "Profile",
      Cell: ({ row }) => (
        <div>
          <label
            htmlFor={`file-upload-${row.original.Admin_id}`}
            style={{ cursor: "pointer" }}
          >
            <img
              src={row.original.Profile}
              alt="Profile"
              style={{
                width: "40px",
                height: "40px",
                borderRadius: "50%",
                objectFit: "cover",
              }}
            />
          </label>
          <input
            type="file"
            id={`file-upload-${row.original.Admin_id}`}
            style={{ display: "none" }}
            onChange={(e) =>
              handleImageUpload(
                row.original.Admin_id,
                e.target.files[0],
                row.original.FullName
              )
            }
          />
        </div>
      ),
    },
    {
      Header: "Name",
      accessor: "FullName",
      className: "table-cell capitalize-text",
    },
    {
      Header: "Gender",
      accessor: "Gender",
      className: "table-cell capitalize-text",
    },
    {
      Header: "Email",
      accessor: "Email",
      className: "table-cell email-cell",
      Cell: ({ row }) => (
        <span className="email-cell">{row.original.Email.toLowerCase()}</span>
      ),
    },
    { Header: "Contact", accessor: "Contact", className: "table-cell" },
    {
      Header: "Address",
      accessor: "Address",
      className: "table-cell capitalize-text",
      Cell: ({ row }) => `${row.original.Address}, ${row.original.Pincode}`,
    },
    {
      Header: "City",
      accessor: "CityName",
      className: "table-cell capitalize-text",
    },
    {
      Header: "State",
      accessor: "State",
    },
    {
      Header: "Country",
      accessor: "CountryName",
      className: "table-cell capitalize-text",
    },
    {
      Header: "Company",
      accessor: "CompanyName",
      className: "table-cell capitalize-text",
    },
    { Header: "DOJ", accessor: "DateofJoin", className: "table-cell" },
  ];

  //for upload image attachment in admin
  const handleImageUpload = (Admin_id, img, AdminName) => {
    setShowUploadConfirm(true);
    setUploadAdminName(AdminName);
    setPendingFile(img); // Store file temporarily
    setPendingAdminId(Admin_id);
    setShowUploadConfirm(true); // Show confirmation modal
  };
  const confirmUpload = async () => {
    if (!pendingFile || !pendingAdminId) return;
    const formData = new FormData();
    formData.append("admin_image", pendingFile);
    setShowUploadConfirm(false);
    setLoading(true);
    try {
      const response = await axios.post(
        `https://aligndesk.dropyourbusiness.com/api/admin/add-image/${pendingAdminId}`,
        formData,
        { headers: { "Content-Type": "multipart/form-data" } }
      );
      if (response.status === 200 || response.status === 201) {
        toast.success("Image uploaded successfully!");
        fetchAdmin(); // Refresh admin data
      } else {
        toast.error("Failed to upload image.");
      }
    } catch (error) {
      console.error("Image upload error:", error);
      toast.error("Image must be a jpg, jpeg, or png file.");
    } finally {
      setLoading(false);
      setShowUploadConfirm(false);
      setPendingFile(null);
      setPendingAdminId(null);
    }
  };

  // Cancel upload (just close the modal)
  const cancelUpload = () => {
    setShowUploadConfirm(false);
    setPendingFile(null);
    setPendingAdminId(null);
  };

  return (
    <div>
      <ToastContainer />
      {loading}
      <div
        className="page-head"
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          fontSize: "10px",
          marginLeft: "1%",
          marginRight: "2%",
        }}
      >
        <h1>
          <FaUserTie /> Admin
        </h1>

        <button className="add-button" onClick={() => openModal()}>
          + Add
        </button>
      </div>

      {loading ? (
        <div className="loader-container">
          <div className="loader"></div>
          <p>Loading...</p>
        </div>
      ) : (
        <TableOne
          columns={columns}
          data={filteredAdmin.slice().reverse()}
          handleEdit={handleEdit}
          handleDelete={handleDelete}
        />
      )}

      {/* Delete Confirmation Modal */}
      {showDeleteAdminBox && (
        <div className="popup-overlay">
          <div className="popup-box">
            <div className="popup-header">
              <CiWarning /> Confirm Delete
            </div>
            <div className="popup-message">
              Are you sure you want to delete Admin{" "}
              <span className="admin-name">
                <strong>{deleteAdminName}</strong>
              </span>{" "}
              from the system?
            </div>
            <div className="popup-buttons">
              <button className="confirm-button" onClick={confirmDeleteAdmin}>
                Yes, Delete
              </button>
              <button className="cancel-button" onClick={cancelDeleteAdmin}>
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
      {showUploadConfirm && (
        <div className="popup-overlay">
          <div className="popup-box">
            <div className="popup-header">
              <CiWarning />
              Confirm Upload
            </div>
            <div className="popup-message">
              Are you sure you want to upload a new profile picture for
              <strong> {uploadAdminName}</strong>?
            </div>
            <div className="popup-buttons">
              <button className="confirm-button" onClick={confirmUpload}>
                Yes, Upload
              </button>
              <button className="cancel-button" onClick={cancelUpload}>
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}

      <Modal
        isOpen={isModalOpen}
        onRequestClose={closeModal}
        contentLabel="Admin Form"
        shouldCloseOnOverlayClick={false}
        className="add-Admin-modal"
        style={{
          content: {
            width: "625px",
          },
        }}
      >
        <h2>{editMode ? "Edit Admin" : "Add Admin"}</h2>
        <form>
          <div className="form-main">
            <div className="form-row">
              <TextField
                label="Full Name"
                name="admin_fullname"
                value={formData.admin_fullname}
                error={!!errors.admin_fullname}
                helperText={errors.admin_fullname}
                onChange={handleInputChange}
                disabled={editMode} // Disable when editing
                fullWidth
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start" style={{ color: "black" }}>
                      <FaUser />
                    </InputAdornment>
                  ),
                }}
              />
              <TextField
                select
                label="Company"
                name="admin_company_id"
                value={formData.admin_company_id}
                error={!!errors.admin_company_id}
                helperText={errors.admin_company_id}
                disabled={editMode} // Disable when editing
                onChange={handleInputChange}
                fullWidth
                style={{ width: "290px" }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start" style={{ color: "black" }}>
                      <FaBuilding />
                    </InputAdornment>
                  ),
                }}
              >
                {company.map((companyData) => (
                  <MenuItem
                    key={companyData.CompanyId}
                    value={companyData.CompanyId}
                  >
                    {companyData.CompanyName}
                  </MenuItem>
                ))}
              </TextField>
            </div>
            <div className="form-row">
              <TextField
                label="Email"
                name="admin_email"
                value={formData.admin_email}
                error={!!errors.admin_email}
                helperText={errors.admin_email}
                disabled={editMode} // Disable when editing
                onChange={handleInputChange}
                fullWidth
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start" style={{ color: "black" }}>
                      <MdEmail />
                    </InputAdornment>
                  ),
                }}
              />
              <TextField
                label="Password"
                name="admin_password"
                value={formData.admin_password}
                error={!!errors.admin_password}
                helperText={errors.admin_password}
                disabled={editMode} // Disable when editing
                onChange={handleInputChange}
                fullWidth
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start" style={{ color: "black" }}>
                      <RiLockPasswordFill />
                    </InputAdornment>
                  ),
                }}
              />
              <TextField
                label="Confirm Password"
                name="admin_confirm_password"
                error={!!errors.admin_confirm_password}
                helperText={errors.admin_confirm_password}
                onChange={handleInputChange}
                disabled={editMode} // Disable when editing
                fullWidth
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start" style={{ color: "black" }}>
                      <RiLockPasswordFill />
                    </InputAdornment>
                  ),
                }}
              />
            </div>
            <div className="form-row" style={{ gap: "21px" }}>
              <div className="gender">
                <FormControl
                  style={{ display: "flex" }}
                  error={!!errors.admin_gender}
                >
                  <FormLabel id="demo-row-radio-buttons-group-label">
                    Gender
                    {errors.admin_gender && (
                      <FormHelperText>{errors.admin_gender}</FormHelperText>
                    )}
                  </FormLabel>
                  <RadioGroup
                    row
                    aria-labelledby="demo-row-radio-buttons-group-label"
                    name="row-radio-buttons-group"
                    value={formData.admin_gender}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        admin_gender: e.target.value,
                      })
                    }
                  >
                    <FormControlLabel
                      value="male"
                      control={<Radio />}
                      label="Male"
                    />
                    <FormControlLabel
                      value="female"
                      control={<Radio />}
                      label="Female"
                    />
                    <FormControlLabel
                      value="other"
                      control={<Radio />}
                      label="Other"
                    />
                  </RadioGroup>
                </FormControl>
              </div>
              <div className="emp-contact">
                <TextField
                  label="Contact"
                  name="admin_contact"
                  value={formData.admin_contact}
                  error={!!errors.admin_contact}
                  helperText={errors.admin_contact}
                  onChange={handleInputChange}
                  fullWidth
                  style={{ marginLeft: "8px", width: "190px" }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment
                        position="start"
                        style={{ color: "black" }}
                      >
                        <FaMobileRetro />
                      </InputAdornment>
                    ),
                  }}
                />
              </div>
              <div className="date-of-join">
                <TextField
                  type="date"
                  label="Date Of Join"
                  name="admin_dateofjoin"
                  value={formData.admin_dateofjoin}
                  error={!!errors.admin_dateofjoin}
                  helperText={errors.admin_dateofjoin}
                  onChange={handleInputChange}
                  InputLabelProps={{ shrink: true }}
                  fullWidth
                  style={{ width: "190px" }}
                />
              </div>
            </div>

            <div className="form-row">
              <TextField
                select
                label="Country"
                name="admin_country"
                value={formData.admin_country}
                error={!!errors.admin_country}
                helperText={errors.admin_country}
                onChange={handleInputChange}
                fullWidth
                style={{ width: "190px" }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start" style={{ color: "black" }}>
                      <GiWorld />
                    </InputAdornment>
                  ),
                }}
              >
                {country.map((countryData) => (
                  <MenuItem
                    key={countryData.CountryId}
                    value={countryData.CountryId}
                  >
                    {countryData.CountryName}
                  </MenuItem>
                ))}
              </TextField>
              <TextField
                select
                label="State"
                name="admin_state"
                value={formData.admin_state}
                error={!!errors.admin_state}
                helperText={errors.admin_state}
                onChange={handleInputChange}
                fullWidth
                style={{ width: "190px" }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start" style={{ color: "black" }}>
                      <FaCity />
                    </InputAdornment>
                  ),
                }}
              >
                {state.map((stateData) => (
                  <MenuItem key={stateData.StateId} value={stateData.StateId}>
                    {stateData.StateName}
                  </MenuItem>
                ))}
              </TextField>
              <TextField
                select
                label="City"
                name="admin_city"
                value={formData.admin_city}
                error={!!errors.admin_city}
                helperText={errors.admin_city}
                onChange={handleInputChange}
                fullWidth
                style={{ width: "190px" }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start" style={{ color: "black" }}>
                      <FaTreeCity />
                    </InputAdornment>
                  ),
                }}
              >
                {city.map((cityData) => (
                  <MenuItem key={cityData.CityId} value={cityData.CityId}>
                    {cityData.CityName}
                  </MenuItem>
                ))}
              </TextField>
            </div>
            <div className="form-row">
              <TextField
                label="Residential Address"
                name="admin_address"
                id="outlined-textarea"
                value={formData.admin_address}
                error={!!errors.admin_address}
                helperText={errors.admin_address}
                onChange={handleInputChange}
                fullWidth
                style={{ width: "400px" }}
                multiline
                rows={1}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start" style={{ color: "black" }}>
                      <FaAddressCard />
                    </InputAdornment>
                  ),
                }}
              />
              <TextField
                label="Pincode"
                name="admin_pincode"
                value={formData.admin_pincode}
                error={!!errors.admin_pincode}
                helperText={errors.admin_pincode}
                onChange={handleInputChange}
                style={{ width: "190px", marginLeft: "5px" }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start" style={{ color: "black" }}>
                      <TbMapPinCode />
                    </InputAdornment>
                  ),
                }}
              />
            </div>
          </div>
          <div>
            <div className="all-button-form">
              <button
                type="submit"
                onClick={handleSubmit}
                className="add-button"
              >
                {editMode ? "Edit" : "+ Add"}
              </button>
              <button type="button" onClick={closeModal} className="btn-cancel">
                Cancel
              </button>
            </div>
          </div>
        </form>
      </Modal>
    </div>
  );
};

export default Admin;
